import Components from "../components";

class Breadcrumbs extends Components.Base {
  bind() {
    // Simple hack to allow for selecting text. Double click does not work
    this.on('mousedown.breadcrumb', evt => {
      this.clickX = evt.screenX;
      this.clickY = evt.screenY;
    });
    this.on('click.breadcrumb.has-metadata', this.toggle.bind(this));
  }

  toggle(evt) {
    if (
      Math.abs(evt.screenX - this.clickX) < 20 &&
      Math.abs(evt.screenY - this.clickY) < 20
    ) {
      $(evt.target)
        .parents('.breadcrumb')
        .toggleClass('metadata-open');
    }
  }
}

Components.collection.register({
  selector: '.c-breadcrumbs',
  klass: Breadcrumbs,
});
